import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareProformaProjectFormsRoute: InvariantJiraRoute = {
	name: 'project-settings-software-proforma-project-forms',
	path: '/jira/software/projects/:projectKey/settings/forms',
	exact: true,
};
